import { useCallback } from "react";

export const useTagLabel = (isEmailView?: boolean | undefined) => {
  const getTagLabel = useCallback(
    (item: any, value: string): string => {
      let name: string;

      const MAX_LENGTH = isEmailView ? 40 : 30;

      if (item) {
        name = item.name;

        if (name.length > MAX_LENGTH) {
          name = name.substring(0, MAX_LENGTH - 1) + " ...";
        }

        if (item.role) {
          name += ` | ${item.role === 1 ? "Buyer" : "Seller"}`;
        }

        if (item.type) {
          name += ` | ${item.type}`;
        }
      } else {
        name = value;
      }

      return name;
    },
    [isEmailView]
  );

  return { getTagLabel };
};
